export const getMfeName = (context) => {
    if (typeof context.mfe === 'string') {
        return context.mfe;
    }
    return 'unknown';
};
